<div class="p-3 mt-1 card border rounded">
  <!-- Title -->
  <div class="mb-3 border-bottom border-secondary-subtle">
    <div class="d-flex flex-column flex-md-row justify-content-between gap-2">
      <div>
        <p class="m-0 text-dark fw-bold fs-4">
          {{ 'CONTRACT.CONTRACT_DETAILS' | translate }}
        </p>
        <p class="m-0 text-muted">
          {{ 'CONTRACT.CONTRACT_DETAILS_DESC' | translate }}
        </p>
      </div>
      <div class="text-md-end">
        <button (click)="onEdit()" class="btn btn-primary btn-sm cursor-pointer">
          <i class="las la-edit"></i>{{ 'CONTRACT.EDIT' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Row 1 -->
  <div class="row gy-3 mb-4">
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.CONTRACT_TYPE' | translate }}</p>
      <p class="m-0">{{ 'CONTRACT.RENTAL_AGREEMENT' | translate }}</p>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.NOTICE_PERIOD' | translate }}</p>
      <p class="m-0">90 {{ 'CONTRACT.DAYS' | translate }}</p>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.STATUS' | translate }}</p>
      <span
        [class]="data()?.contractStatus == '1' ? 'border-primary text-primary bg-primary-subtle' : 'border-danger text-danger bg-danger-subtle'"
        class="fs-6 border px-2 py-1 rounded d-inline-block">
        <span *ngIf="data()?.contractStatus == '1'">{{ 'CONTRACT.ACTIVE' | translate }}</span>
        <span *ngIf="data()?.contractStatus == '2'">{{ 'CONTRACT.INACTIVE' | translate }}</span>
      </span>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.MONTHLY_PAYMENT' | translate }}</p>
      <p class="m-0">{{ data()?.totalRent | moneyFormat }}</p>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="row gy-3 mb-4">
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.START_DATE' | translate }}</p>
      <p class="m-0">
        {{ data()?.startDate ? (data()?.startDate | localizedDate: 'MM/dd/yyyy') : '-' }}
      </p>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.END_DATE' | translate }}</p>
      <p class="m-0">
        {{ data()?.permanent ? ('CONTRACT.PERMANENT' | translate) : (data()?.endDate ? (data()?.endDate | localizedDate: 'MM/dd/yyyy') : '-') }}
      </p>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.RENEWAL_DATE' | translate }}</p>
      <p class="m-0">{{ data()?.terminationExtensionDate || '-' }}</p>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.RESIDENTS_COUNT' | translate }}</p>
      <p class="m-0">{{ data()?.residentsQuantity || '-' }}</p>
    </div>
  </div>

  <!-- Row 3 -->
  <div class="row gy-3 mb-4">
    <div class="col-12 col-md-6 col-lg-3">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.ROOMS_COUNT' | translate }}</p>
      <p class="m-0" style="white-space: pre-wrap;">{{ data()?.roomsQuantity || '-'}}</p>
    </div>
    <div class="col-12 col-md-6 col-lg-9">
      <p class="fw-bold fs-5 mb-1">{{ 'CONTRACT.NOTES' | translate }}</p>
      <p class="m-0" style="white-space: pre-wrap;">{{ data()?.notes }}</p>
    </div>
  </div>
</div>
